import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./MainScreen.css";
import ProjectPreview from "../../components/ProjectPreview/ProjectPreview";
import { useNavigate } from "react-router-dom";
// import SortIcon from "../../assets/sort.svg";
import { ReactComponent as SortIcon } from "../../assets/sort-icon-color.svg";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import searchIcon from "../../assets/search.svg";
import { ReactComponent as PlusIcon } from "../../assets/plus-icon.svg";
import rootFolderIcon from "../../assets/rootfolder.svg";
import { useTranslation } from "react-i18next";
import AddProjectModal from "../../components/AddProjectModal/AddProjectModal";
import arrowDown from "../../assets/arrowDown.svg";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import { useAuth } from "../../context/AuthContext";
import {
  createOrganization,
  deleteProject,
  fetchProjects,
  fetchSharedProjects,
  forceDeleteProject,
  resetProjectsExplorer,
  updateProjectArchiveStatus,
} from "../../store/projectsSlice";
import {
  projectsSelector,
  userSelector,
  currentOrganizationSelector,
  appSelector,
  projectsArchivedSelector,
  currentActiveProjectsAmountSelector,
  organizationsListSelector,
  redirectUrlSelector,
} from "../../store/selectors";
import ProjectExplorer from "../../components/ProjectExplorer/ProjectExplorer";
import { OrbitProgress } from "react-loading-indicators";
import {
  fetchNotifications,
  setIsAppLoading,
  setIsMainLoaded,
  setRedirectUrl,
} from "../../store/appSlice";
import EditProjectModal from "../../components/EditProjectModal/EditProjectModal";
import EditProjectPosterModal from "../../components/EditProjectPosterModal/EditProjectPosterModal";
import AddOrganizationModal from "../../components/AddOrganizationModal/AddOrganizationModal";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import { fetchCurrentOrgSubscription } from "../../store/tariffesSlice";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import SearchField from "../../components/SearchField/SearchField";
import useIsMobile from "../../hooks/useIsMobile";
import { updateTariffes } from "../../helpers/helpers";
import useOrganizationLimits from "../../hooks/useOrganizationLimits";
import toast from "react-hot-toast";

function MainScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const limits = useOrganizationLimits();
  const organizations = useSelector(organizationsListSelector);
  const currentprojectsArray = useSelector(projectsSelector);
  const archivedProjectsArray = useSelector(projectsArchivedSelector);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isArchiveHovered, setIsArchiveHovered] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const projectsArray = showArchived
    ? archivedProjectsArray
    : currentprojectsArray;

  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("newest");
  const [showSortMenu, setShowSortMenu] = useState(false);
  const sortMenuRef = useRef(null);

  useEffect(() => {
    const redirectUrl = localStorage.getItem("redirectUrl");
    if (redirectUrl) {
      localStorage.removeItem("redirectUrl");
      navigate(redirectUrl);
    }
  }, []);

  // Sorting logic (must be before usage)
  const getSortedProjects = (projects) => {
    let arr = [...projects];
    switch (sortOption) {
      case "newest":
        arr.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
        break;
      case "oldest":
        arr.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
        break;
      case "az":
        arr.sort((a, b) => (a.title || "").localeCompare(b.title || "", "ru"));
        break;
      case "za":
        arr.sort((a, b) => (b.title || "").localeCompare(a.title || "", "ru"));
        break;
      default:
        break;
    }
    return arr;
  };

  const filteredProjects = projectsArray.filter((project) => {
    return project.title.toLowerCase().includes(searchQuery.toLowerCase());
  });
  const sortedProjects = getSortedProjects(filteredProjects);
  const user = useSelector(userSelector);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
  const { logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
  const [isOrgPopupOpen, setIsOrgPopupOpen] = useState(false);
  const app = useSelector(appSelector);
  const [currentExtendedProjectId, setCurrentExtendedProjectId] = useState("");
  const userName = user.email;
  const [projectToRename, setProjectToRename] = useState(null);
  const [projectToChangeCover, setProjectToChangeCover] = useState(null);
  const [isAddOrganizationModalOpen, setIsAddOrganizationModalOpen] =
    useState(false);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, []);

  useEffect(() => {
    fetchCurrentProjects();
    dispatch(setIsMainLoaded(true));
  }, [showArchived]);

  const fetchCurrentProjects = (withReset = false) => {
    dispatch(
      fetchProjects({
        organizationId: currentOrganization.id,
        isDeleted: showArchived,
      })
    ).then((res) => {
      if (!res.error) {
        dispatch(setIsAppLoading(false));
        if (withReset) {
          dispatch(resetProjectsExplorer());
        }
      }
    });
    dispatch(
      fetchSharedProjects({
        organizationId: currentOrganization.id,
        isDeleted: false,
      })
    );
    updateTariffes(user.organizations, dispatch);
  };

  const handleArchiveProject = (projectId, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (window.confirm(t("projectScreen.confirmArchive"))) {
      dispatch(
        updateProjectArchiveStatus({ projectId, isArchived: true })
      ).then((res) => {
        toast.success("Проект перемещен в архив");
        fetchCurrentProjects(true);
      });
    }
  };

  const handleDeleteProject = (projectId, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (window.confirm(t("projectScreen.confirmDelete"))) {
      dispatch(forceDeleteProject(projectId)).then((res) => {
        if (!res.error) {
          toast.success("Проект удален");
          fetchCurrentProjects(true);
        }
      });
    }
  };

  const onPressPlus = () => {
    if (!limits) {
      toast.error("У рабочего пространства отсутствует тариф");
      return;
    }
    const projectsLimit = limits.find(
      (limit) => limit.attributeCode === "AVAILABLE_PROJECT_COUNT"
    );
    if (
      projectsLimit &&
      projectsLimit.usedValue >= projectsLimit.maxValue &&
      projectsLimit.maxValue !== -1
    ) {
      toast.error(
        "Ваш текущий тариф не позволяет создать большее количество проектов."
      );
      return;
    }
    setIsAddProjectModalOpen(true);
  };

  const handleRenameProject = (event, projectId) => {
    event.preventDefault();
    event.stopPropagation();
    const project = projectsArray.find((p) => p.id === projectId);
    setProjectToRename(project);
  };

  const handleChangeCover = (event, projectId) => {
    event.preventDefault();
    event.stopPropagation();
    const project = projectsArray.find((p) => p.id === projectId);
    setProjectToChangeCover(project);
  };

  const renderProject = (projectInfo, index) => {
    if (projectInfo.isUploading) {
      return (
        <ProjectPreview
          index={index}
          projectInfo={projectInfo}
          key={projectInfo.id}
          isUploading={true}
          isArchive={showArchived}
        />
      );
    }

    return (
      <ProjectPreview
        index={index}
        projectInfo={projectInfo}
        key={projectInfo.id}
        onClick={() => {
          if (!showArchived) {
            navigate(`/projects/${projectInfo.id}`);
          }
        }}
        onArchive={handleArchiveProject}
        onDelete={handleDeleteProject}
        isArchive={showArchived}
        onRename={(e) => handleRenameProject(e, projectInfo.id)}
        onChangeCover={(e) => handleChangeCover(e, projectInfo.id)}
      />
    );
  };
  useEffect(() => {
    if (!showSortMenu) return;
    const handleClickOutside = (event) => {
      if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
        setShowSortMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSortMenu]);

  const showTeamPopup = () => {
    setShowOrganizationPopup(true);
    setShowUserMenu(false);
  };

  const handleOrganizationChange = (organization) => {
    setIsPageLoading(true);
    dispatch({ type: "SET_CURRENT_ORGANIZATION", payload: organization });
    dispatch(
      fetchProjects({
        organizationId: organization.id,
        isDeleted: false,
      })
    ).then((res) => {
      if (!res.error) {
        setShowArchived(false);
        setIsPageLoading(false);
        dispatch(resetProjectsExplorer());
      }
    });
    dispatch(fetchCurrentOrgSubscription({ orgId: organization.id }));
    setShowOrganizationPopup(false);
  };

  const renderDummy = () => {
    return (
      <div className="mainScreen-empty-state">
        <div className="empty-state-message">
          {t("mainScreen.projects.no_projects")}
        </div>
      </div>
    );
  };

  const getNumberedLocalizedString = (amount, key) => {
    let keyLocalized = `${key}_1`;
    if (amount % 10 === 1) {
      keyLocalized = `${key}_1`;
    } else if (amount % 10 > 1 && amount % 10 <= 4) {
      keyLocalized = `${key}_2`;
    } else if (amount % 10 === 0 || amount % 10 > 4) {
      keyLocalized = `${key}_3`;
    }

    return `${amount} ${t(keyLocalized)}`;
  };

  const handleAddOrganization = () => {
    setIsAddOrganizationModalOpen(true);
  };

  const handleOrganizationCreated = (data) => {
    dispatch(createOrganization(data)).then((res) => {
      if (!res.error) {
        dispatch({
          type: "SET_CURRENT_ORGANIZATION",
          payload: res.payload,
        });
        dispatch(
          fetchProjects({
            organizationId: res.payload.id,
            isDeleted: showArchived,
          })
        ).then((res) => {
          if (!res.error) {
            dispatch(resetProjectsExplorer());
          }
        });
      }
    });
  };

  if (app.isAppLoading) {
    return (
      <div className="App">
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <OrbitProgress color="#C1C7D4" />
        </div>
      </div>
    );
  }

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate(0, { replace: true })}
            className={"mainScreen-logoBlock"}
          >
            <img src={AppLogo} style={{ height: "80%" }} />
          </div>
          <div
            style={{
              marginLeft: 163,
              color: "white",
              fontFamily: "NT Somic",
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            {!isMobile && "Мои проекты"}
          </div>
          <div className="projects-filter"></div>
        </div>
        <div className="header-actions">
          {!isMobile && (
            <>
              <SearchField onValueChanged={(value) => setSearchQuery(value)} />
            </>
          )}
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      <div className="projects-container-content">
        {(!isMobile || isMenuOpen) && (
          <ProjectExplorer
            isMobile={isMobile}
            limits={limits}
            organizations={organizations}
            currentProject={null}
            currentOrganization={currentOrganization}
            isOrgPopupOpen={isOrgPopupOpen}
            onOrganizationSelect={handleOrganizationChange}
            onAddOrganization={handleAddOrganization}
            onOrganizationClick={() => setIsOrgPopupOpen(!isOrgPopupOpen)}
            isPageLoading={isPageLoading}
            showArchived={showArchived}
          />
        )}
        <div className="main-projects-container-folders">
          {!showArchived && !isPageLoading && projectsArray.length === 0 && (
            <div className="projects-container-dummy">
              <div className="projects-container-dummy-title">
                {t("mainScreen.projects.dummy.title")}
                {` ${currentOrganization.title}`}
              </div>
              <span className="projects-container-dummy-subtitle">
                {t("mainScreen.projects.dummy.subtitle")}
              </span>
              <button
                onClick={onPressPlus}
                className="projects-container-dummy-button"
              >
                <PlusIcon
                  className="main-projects-add-btn-plus-icon"
                  style={{
                    transform: "scale(0.9)",
                  }}
                />
                {t("mainScreen.projects.dummy.button")}
              </button>
            </div>
          )}
          {!isPageLoading && (showArchived || projectsArray.length !== 0) && (
            <div className="main-projects-folders-header">
              <span className="main-projects-title">
                {getNumberedLocalizedString(
                  projectsArray.length,
                  "mainScreen.projects.title"
                )}
              </span>
              <button
                className="main-projects-add-btn"
                style={{ display: showArchived ? "none" : "flex" }}
                onClick={onPressPlus}
              >
                <PlusIcon
                  className="main-projects-add-btn-plus-icon"
                  style={{
                    transform: "scale(0.9)",
                  }}
                />
                {!isMobile && t("mainScreen.projects.add")}
              </button>
              {!isMobile && (
                <div className="main-projects-filter-buttons">
                  {true && (
                    <button
                      className={`filter-btn ${
                        !showArchived ? "filter-btn--active" : ""
                      }`}
                      onClick={() => setShowArchived(false)}
                      style={{
                        color: !showArchived
                          ? "#F1F7FF"
                          : isArchiveHovered
                            ? "#C1C7D4"
                            : "#717B8E",
                      }}
                      onMouseEnter={() => setIsArchiveHovered(true)}
                      onMouseLeave={() => setIsArchiveHovered(false)}
                    >
                      {t("mainScreen.projects.filter.all")}
                    </button>
                  )}
                  <button
                    className={`filter-btn ${
                      showArchived ? "filter-btn--active" : ""
                    }`}
                    onClick={() => setShowArchived(true)}
                    style={{
                      color: showArchived
                        ? "#F1F7FF"
                        : isArchiveHovered
                          ? "#C1C7D4"
                          : "#717B8E",
                    }}
                    onMouseEnter={() => setIsArchiveHovered(true)}
                    onMouseLeave={() => setIsArchiveHovered(false)}
                  >
                    {t("mainScreen.projects.filter.archived")}
                  </button>
                  <div
                    ref={sortMenuRef}
                    className="sort-icon-btn"
                    style={{
                      width: 32,
                      height: 32,
                      marginLeft: 10,
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      justifyContent: "center",
                      position: "relative",
                    }}
                    onClick={() => setShowSortMenu((v) => !v)}
                  >
                    <SortIcon />
                    {/* <img src={SortIcon} style={{ width: 28, height: 28 }} /> */}
                    {showSortMenu && (
                      <div className="main-sort-menu">
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "newest" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("newest");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "newest" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          Сначала новые
                        </div>
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "oldest" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("oldest");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "oldest" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          Сначала старые
                        </div>
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "az" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("az");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "az" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          От А до Я
                        </div>
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "za" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("za");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "za" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          От Я до А
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          {!isPageLoading && projectsArray.length !== 0 && (
            <>
              <div
                className={
                  isMobile ? "main-projects-list-mobile" : "main-projects-list"
                }
              >
                {projectsArray.length > 0
                  ? sortedProjects.map((project, index) =>
                      renderProject(project, index)
                    )
                  : renderDummy()}
              </div>
            </>
          )}
          {showArchived && !isPageLoading && projectsArray.length === 0 && (
            <>
              <div className="main-projects-list">
                {projectsArray.length > 0
                  ? sortedProjects.map((project, index) =>
                      renderProject(project, index)
                    )
                  : renderDummy()}
              </div>
            </>
          )}
          {isPageLoading && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <OrbitProgress color="#C1C7D4" />
            </div>
          )}
        </div>
      </div>
      {isAddProjectModalOpen && (
        <AddProjectModal
          isOpen={isAddProjectModalOpen}
          onClose={() => setIsAddProjectModalOpen(false)}
        />
      )}
      {projectToRename && (
        <EditProjectModal
          project={projectToRename}
          onRenamed={() => fetchCurrentProjects(true)}
          onClose={() => setProjectToRename(null)}
        />
      )}
      {projectToChangeCover && (
        <EditProjectPosterModal
          project={projectToChangeCover}
          onPosterUpdated={() => fetchCurrentProjects(true)}
          onClose={() => setProjectToChangeCover(null)}
        />
      )}
      {showOrganizationPopup && (
        <div className="modal-overlay">
          <div className="modal-content organization-popup">
            <h2>{t("mainScreen.organization.title")}</h2>
            <div className="organization-list">
              {organizations.map((org) => (
                <div key={org.id} className="organization-item">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="organization"
                      checked={currentOrganization.id === org.id}
                      onChange={() => handleOrganizationChange(org)}
                    />
                    <span title={org.title || org.name || org.email}>
                      {(org.title || org.name || org.email).length > 40
                        ? (org.title || org.name || org.email).slice(0, 40) +
                          "..."
                        : org.title || org.name || org.email}
                    </span>
                  </label>
                </div>
              ))}
            </div>
            <button
              className="org-close-button"
              onClick={() => setShowOrganizationPopup(false)}
            >
              {t("common.close")}
            </button>
          </div>
        </div>
      )}
      {isAddOrganizationModalOpen && (
        <AddOrganizationModal
          isOpen={isAddOrganizationModalOpen}
          onClose={() => setIsAddOrganizationModalOpen(false)}
          onOrganizationCreated={handleOrganizationCreated}
        />
      )}
    </div>
  );
}

export default MainScreen;
